import { ModalService } from './../shared/services/utils/modal.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { API_URL } from './../config/api.constant';
import { Injectable } from '@angular/core';
import { Router, NavigationExtras } from '@angular/router';
import { Observable, of, throwError } from 'rxjs';
import { map, catchError, tap } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as Config from 'src/app/config/app.constant';
import { environment } from 'src/environments/environment';
import { User, UserService, UserModel } from './user.service';

@Injectable({ providedIn: 'root' })

export class AuthService {

  private jwtObject: any;
  private jwtHelper: JwtHelperService = new JwtHelperService();
  redirectUrl: string;
  isLoggedIn: boolean = false;

  constructor(
    private http: HttpClient,
    private router: Router,
    private userService: UserService
  ) { }

  login(user: User): Observable<any> {
    if (this.isLoggedIn) {
      return of(true);
    }

    if (user.username !== '' && user.password !== '') {
      const url = API_URL.login;
      const body = { username: user.username, password: user.password };
      return this.http.post<any>(url, body).pipe(
        tap(() => { }, (error) => {
          this.isLoggedIn = false;
          return throwError(error);
        }));
    }
  }

  setResponse(response: any): Observable<boolean> {
    if (response.value.customer.token) {
      this.jwtObject = this.jwtHelper.decodeToken(response.value.customer.token);
      this.isLoggedIn = true;
      this.userService.setJwtObject(this.jwtObject);
      return of(this.isLoggedIn);
    } else {
      throw throwError(response.error_description);
    }
  }

  logout(): void {
    sessionStorage.clear();
    localStorage.clear();
    this.isLoggedIn = false;
    this.router.navigate(['/']);
  }

  checkAuthen(): void {
    const token = this.getSmartclaimToken();
    if (token) {
      this.jwtObject = this.jwtHelper.decodeToken(token);
      this.isLoggedIn = !this.jwtHelper.isTokenExpired(token);
      this.userService.setJwtObject(this.jwtObject);
      this.userService.userModel = this.getUserDetail();
      if (this.isLoggedIn) {
        const url = this.redirectUrl === undefined ? '/home' : this.redirectUrl;
        this.redirectPage(url);
      } else {
        this.redirectPage('/login');
      }
    }
  }

  getSmartclaimToken(): string {
    return sessionStorage.getItem(Config.SMARTCLAIM_TOKEN_KEY) || '';
  }

  getAdminToken(): string {
    return sessionStorage.getItem(Config.ADMIN_TOKEN_KEY) || '';
  }

  getUserDetail(): UserModel {
    return JSON.parse(sessionStorage.getItem(Config.USER_DETAIL));
  }

  redirectPage(redirect: string): void {
    const navigationExtras: NavigationExtras = {
      preserveQueryParams: true,
      preserveFragment: true
    };
    this.router.navigate([redirect], navigationExtras);
  }
}
